import React from 'react';
import { Block } from '@mui/icons-material';

const L2Videos = () => {
  // Array of 24 video examples with individual URLs and descriptions
  const videoExamples = [
    { id: 1, url: 'https://i.postimg.cc/PJb7cb4h/2-ND-PHONE-SPAWNING.gif', description: 'Phone spawning in other hand' },
    { id: 2, url: 'https://i.postimg.cc/DzWMF3gx/2-ND-PHONE-SPAWNING-1.gif', description: 'Phone spawning in other hand' },
    { id: 3, url: 'https://i.postimg.cc/sfP03cYC/2-ND-PHONE-SPAWNING-3.gif', description: 'Camera spawning' },
    { id: 4, url: 'https://i.postimg.cc/C54vJhhx/3-RD-ARM-SPAWNING.gif', description: 'Hand disappearing' },
    { id: 5, url: 'https://i.postimg.cc/CKW6xrrS/3rd-ARM-SPAWNING-2.gif', description: '3rd arm on the left spawning' },
    { id: 6, url: 'https://i.postimg.cc/KvJqM8p9/3-RD-ARM-SPWANING.gif', description: '3rd arm spawning' },
    { id: 7, url: 'https://i.postimg.cc/BnbhcfdJ/4-FINGERS-IN-HAND.gif', description: 'Left hand weird fingers moves' },
    { id: 8, url: 'https://i.postimg.cc/JnVPLDth/BODY-SW-ITCH.gif', description: '360 body is wrong' },
    { id: 9, url: 'https://i.postimg.cc/cCTmwFhK/DISAPPEARING.gif', description: 'Character disappear' },
    { id: 10, url: 'https://i.postimg.cc/6p804Lv3/DISAPPEARING-2.gif', description: 'Character appear out of nowhere' },
    { id: 11, url: 'https://i.postimg.cc/x1BPvJvP/GLITCH-BUG.gif', description: 'Character disappear' },
    { id: 12, url: 'https://i.postimg.cc/C1gH236B/HAND-BUG.gif', description: 'Hand bug + environment moving weirdly' },
    { id: 13, url: 'https://i.postimg.cc/nrVKFvxn/HAND-OUT-OF-MIRROR.gif', description: 'Hand going out or the mirror' },
    { id: 14, url: 'https://i.postimg.cc/xjgysFG8/MOVING-OBJECT.gif', description: 'Weird environment move' },
    { id: 15, url: 'https://i.postimg.cc/kX4NLFwc/NOT-MOVING.gif', description: 'She is not moving ? 1' },
    { id: 16, url: 'https://i.postimg.cc/6p4rpWk4/NOT-MOVING-2.gif', description: 'She is not moving ? 2' },
    { id: 17, url: 'https://i.postimg.cc/5tcwYcJ7/PHONE-APPEARING.gif', description: 'Hand coming out of nowhere' },
    { id: 18, url: 'https://i.postimg.cc/Xvw9927V/WEIRD-HAND-MOTION.gif', description: 'Bad hand move' },
    { id: 19, url: 'https://i.postimg.cc/cH0whQrf/WEIRD-HAND-MOTION-2.gif', description: 'Bad hand move' },
    { id: 20, url: 'https://i.postimg.cc/C5KDTSC1/WEIRD-HAND-SHAPE.gif', description: 'Bad hand move in the middle' },
    { id: 21, url: 'https://i.postimg.cc/MG8QZy0g/WEIRD-HAND-SHAPE-6-FINGERS.gif', description: '6 fingers on the left' },
    { id: 22, url: 'https://i.postimg.cc/NGNm82Yr/WEIRD-HAND-SHAPE-2.gif', description: 'Bad hand move on the right' },
    { id: 23, url: 'https://i.postimg.cc/Dy8sxfyp/WEIRD-HAND-SHAPE-3.gif', description: 'Shoes problem' },
    { id: 24, url: 'https://i.postimg.cc/VNBbJdDv/WEIRD-HAND-SHAPE-4.gif', description: 'Hand problem' }
  ];

  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Video issues and mistakes to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--videos-grid">
            {videoExamples.map((video) => (
              <div key={video.id} className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={video.url} alt={`Video issue ${video.id}`} />
                </div>
                <div className="help-center__image-caption">
                  {video.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default L2Videos;